<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="addRewardConfig.isOpen"
    id="add-reward"
  >
  <div class="flex items-center justify-between px-6">
    <h4 class="text-2xl font-bold">Add New Reward</h4>
    <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
  </div>
  <vs-divider class="mb-0"></vs-divider>

    <div class="sidebar-content p-6">
      <div class="info-form">
        <!-- <label>Reward name</label> -->
        <h4 class="text-lg font-bold m-0">Reward name</h4>
        <vs-input v-validate="'required'" name="name" v-model="name" class="w-full" :danger="errors.has('name')"
              danger-text="The name field is required"/>
        <h4 class="text-lg font-bold mt-base">What is the value of offer?</h4>
        <div class="w-row">
          <ul class="centerx flex align-center justify-between">
            <vs-input-number maxlength="3" min="0" :max="max" v-model="reward_logic_value" :key="input_number_key" class="w-7/12"/>
              <li @click="max=100,input_number_key++">
                <vs-radio v-model="reward_logic_type" vs-value="percent" class="flex align-center m-0">%</vs-radio>
              </li>
              <li @click="max=999,input_number_key++" class="mr-base">
                <vs-radio v-model="reward_logic_type" vs-value="usd" class="flex align-center m-0">$</vs-radio>
              </li>
          </ul>
        </div>
        <!-- <label>Point</label> -->
        <h4 class="text-lg font-bold m-0 mt-base">Point</h4>
        <vs-input :maxlength="11" v-validate="'required'" name="point" placeholder="Please input a point" v-model="point" class="w-full" :danger="errors.has('point')"
              danger-text="The point field is required" v-on:keypress="isNumber($event)"/>
      </div>
    </div>
    <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
      <vs-button class="mr-6" @click.stop="addReward" style="min-width: 140px;">Submit</vs-button>
      <vs-button type="border" color="danger" @click.stop="closeSidebar" style="min-width: 140px;">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
export default {
  name: "vs-add-reward",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue")
  },
  props: {
    addRewardConfig: {
      type: Object,
      required: true
    },
    rewardData: {
      type: Object,
      required: true
    },
    // currentPage:{
    //   type: Number,
    //   required: true
    // },
    // isExistName:{
    //   type: Boolean,
    //   required: true
    // }
  },
  data(){
    return {
      name: '',
      point: '',
      reward_logic_type: 'percent',
      reward_logic_value: 0,
      currentPage: 1,
      itemsPerPage: 10,
      search:'',
      max: 100,
      input_number_key: 0,
    }
  },
  watch:{
    addRewardConfig: {
      immediate: true,
      deep: true,
      handler() {
        this.reward_logic_value = 0,
        this.reward_logic_type = 'percent',
        this.name = '',
        this.point = ''
        this.errors.clear();

        if(this.addRewardConfig.isOpen) {
          document.body.classList.add('overflow-hidden');
          // document.body.requestFullscreen();
          // window.scrollTo(0, window.pageYOffset + 1);
          window.scrollTo(0,1);
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      }
    }
  },
  methods: {
    isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)){
            evt.preventDefault();
        } else {
            return true;
        }
    },
    closeSidebar() {
      this.$emit("CloseSidebar");
    },
    addReward(){
      window.scrollTo(0,1);
      if(this.name != '' && this.point != ''){
        const obj={
          page: this.currentPage,
         'per-page': this.itemsPerPage,
          content : this.name,
          point: this.point,
          logic_type: this.reward_logic_type,
          logic_value: this.reward_logic_value,
          search: this.search
        }
        // this.name = "",
        // this.point = "",
        this.reward_logic_type = "percent",
        this.reward_logic_value = 0;
        this.$emit("AddReward", obj)
      }
      this.$validator.validateAll();
    }
  },
}
</script>
